import { isNativeMobile, nativeInvoke } from './nativeBridge';

// Fire-and-forget shell hints. App builds that predate a method reject it, which is ignored.
const hint = (method: string) => {
  if (isNativeMobile()) nativeInvoke('WiseFriendMobile', method).catch(() => undefined);
};

/** A light system tap haptic; Android honours the user's touch-feedback setting. */
export const nativeTapFeedback = () => hint('tapFeedback');

/** Reveals the page behind the native launch screen, which otherwise stays up for a capped time. */
export const releaseNativeLaunchScreen = () => hint('launchReady');
